export default {
  hosting: state => state.hosting,
  hosting_detail: state => state.hosting_detail,
  hosting_error: state => state.hosting_error,
  hostingPopulated: state => state.hostingPopulated,
  hostingDomainsList: state => state.domainsList.slice(),
  hostingSubdomainsList: state => state.subdomainsList.slice(),
  resellerSubAccounts: state => state.resellerSubAccounts,
  getResellerPackages: state => state.resellerPackages,
  getResellerFeatureLists: state => state.resellerFeatureLists,
  getResellerThemes: state => state.resellerThemes,
  getResellerFeatures: state => state.resellerFeatures,
  getResellerPrivileges: state => state.resellerPrivileges,
  resellerZones: state => state.resellerZones.slice(),
}
